import { create } from 'zustand';
import {AppSecurityModel, apiClient, EnumKeyValue} from '@Models';

type AuthStore = {
    appSecurityModel: AppSecurityModel | null;
    permissions: EnumKeyValue[] | null;
    loadAppSecurityModel: () => Promise<void>;
}

export const useAuthStore = create<AuthStore>(set => ({
    appSecurityModel: null,
    permissions: null,

    loadAppSecurityModel: async () => {
        const [ settings, permissions ] = await Promise.all([apiClient.securityAppSettingsGet(), apiClient.securityPrincipalPermissionsGet()]);

        set({ appSecurityModel: {...settings?.data}, permissions: [...permissions?.data]} );
    }
}))